export default __webpack_public_path__ + "static/media/lates.1e6f64f2.png";